import { render, staticRenderFns } from "./DeliveryAddressView.vue?vue&type=template&id=21f7fb5b&scoped=true&"
import script from "./DeliveryAddressView.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressView.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryAddressView.vue?vue&type=style&index=0&id=21f7fb5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7fb5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f7fb5b')) {
      api.createRecord('21f7fb5b', component.options)
    } else {
      api.reload('21f7fb5b', component.options)
    }
    module.hot.accept("./DeliveryAddressView.vue?vue&type=template&id=21f7fb5b&scoped=true&", function () {
      api.rerender('21f7fb5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryAddressView.vue"
export default component.exports